import { format } from "date-fns";
import { it } from 'date-fns/locale/it';
import { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useAppDispatch, useAppSelector } from '../../lib/redux/hooks';
import { CustomAccordion } from "../../ui/molecules/accordion";
import { Calendar } from "../../ui/molecules/calendar";
import { MadfarmInput } from "../../ui/molecules/input/newInput";
import { MadfarmStaticSelect } from "../../ui/molecules/select/newSelect/static";
import TextArea from "../../ui/molecules/textArea/TextArea";
import { Province, Region, genreSelect, regioniProvinceMap, regions } from "../../utils";
import { provinceComuniMap } from "../../utils/listaComuni";
import { setActivationDate, setAddress, setBirthDate, setCity, setContactCity, setContactCountryRegion, setContactProvince, setContactZipCode, setCountryRegion, setDeActivationDate, setEmail, setFax, setFiscalCode, setName, setNote, setPhone, setProvince, setRappLegaleMobilePhone, setSex, setSurname } from "./slice";
import './style.scss';


registerLocale('it', it)

type OptionType = {
    value: string;
    label: string;
};

export function BoxRappLegale() {
    const clientiState = useAppSelector(state => state.clienti)

    const dispatch = useAppDispatch()
    const [expanded, setExpanded] = useState<string | false>("panel1");
    const handleToggleAccordion = (panel: string) => {
        setExpanded(expanded === panel ? false : panel);
    };

    const [dateActivate, setDataActivate] = useState<Date | undefined>(undefined)
    const [dateDeActivate, setDataDeActivate] = useState<Date | undefined>(undefined)
    const [dateBirthDate, setDateBirthDate] = useState<Date | undefined>(undefined)
    const [provinceOptions, setProvinceOptions] = useState<OptionType[]>([]);
    const [rpProvinceOptions, setRpProvinceOptions] = useState<OptionType[]>([]);
    const [selectedRegion, setSelectedRegion] = useState<OptionType | null>(null);
    const [comuneOptions, setComuneOptions] = useState<OptionType[]>([]);

    const [selectedComune, setSelectedComune] = useState<OptionType | null>(null);
    const [selectedProvince, setSelectedProvince] = useState<OptionType | null>(null);

    //rp
    const [selectedRpRegion, setSelectedRpRegion] = useState<OptionType | null>(null);
    const [selectedRpComune, setSelectedRpComune] = useState<OptionType | null>(null);
    const [selectedRpProvince, setSelectedRpProvince] = useState<OptionType | null>(null);
    const [rpComuneOptions, setRpComuneOptions] = useState<OptionType[]>([]);

    const regionOptions: OptionType[] = Array.from(regioniProvinceMap.keys()).map(region => ({
        value: region,
        label: region
    }));

    useEffect(() => {
        if (selectedRegion) {
            const foundRegion = regions.find((region: Region) => region.name === selectedRegion.toString());
            if (foundRegion) {
                const newProvinceOptions = foundRegion.provinces.map((province: Province) => ({
                    value: province.code,
                    label: province.name
                }));
                setProvinceOptions(newProvinceOptions);
            } else {
                setProvinceOptions([]);
            }
        } else {
            setProvinceOptions([]);
        }
    }, [selectedRegion]);

    useEffect(() => {
        if (selectedProvince) {
            const comuni = provinceComuniMap.get(selectedProvince.toString()) || [];
            const newComuneOptions = comuni.map((comune: string) => ({
                value: comune,
                label: comune
            }));
            setComuneOptions(newComuneOptions);
        } else {
            setComuneOptions([]);
        }
    }, [selectedProvince]);

    //regioni, province, comuni rp
    useEffect(() => {
        if (selectedRpRegion) {
            const foundRegion = regions.find((region: Region) => region.name === selectedRpRegion.toString());
            if (foundRegion) {
                const newProvinceOptions = foundRegion.provinces.map((province: Province) => ({
                    value: province.code,
                    label: province.name
                }));
                setRpProvinceOptions(newProvinceOptions);
            } else {
                setRpProvinceOptions([]);
            }
        } else {
            setRpProvinceOptions([]);
        }
    }, [selectedRpRegion]);

    useEffect(() => {
        if (selectedRpProvince) {
            const comuni = provinceComuniMap.get(selectedRpProvince.toString()) || [];
            const newComuneOptions = comuni.map((comune: string) => ({
                value: comune,
                label: comune
            }));
            setRpComuneOptions(newComuneOptions);
        } else {
            setRpComuneOptions([]);
        }
    }, [selectedRpProvince]);



    const handleRegionChange = (selectedOption: OptionType | null) => {
        setSelectedRegion(selectedOption);
        setSelectedProvince(null); // Reset province when region changes
        setSelectedComune(null);
    };

    const handleRpRegionChange = (selectedOption: OptionType | null) => {
        setSelectedRpRegion(selectedOption);
        setSelectedRpProvince(null); // Reset province when region changes
        setSelectedRpComune(null);
    };

    const handleRpProvinceChange = (selectedOption: OptionType | null) => {
        setSelectedRpProvince(selectedOption);
        setSelectedRpComune(null);
    };

    const handleProvinceChange = (selectedOption: OptionType | null) => {
        setSelectedProvince(selectedOption);
        setSelectedComune(null);
    };

    const handleComuneChange = (selectedOption: OptionType | null) => {
        setSelectedComune(selectedOption);
    };

    return (
        <div className="p-6 flex flex-col gap-6">
            <CustomAccordion
                id="panel1"
                title={<span className="text-uppercase text-white label-input">Rappresentante Legale</span>}
                expanded={expanded === 'panel1'}
                onChange={() => handleToggleAccordion('panel1')}
                detailsClassName="flex flex-col gap-4"
            >
                <div className='grid grid-cols gap-4'>
                    <MadfarmInput
                        label={'Codice Fiscale'}
                        placeholder="Codice Fiscale"
                        supportingText={clientiState.createLegalRappErrors.fiscalCode ? "Inserire codice fiscale (min 16 caratteri)." : undefined} error={clientiState.createLegalRappErrors.fiscalCode}
                        defaultValue={clientiState.rappLegaleEditCreateRequest.fiscalCode}
                        onChangeText={(text) => dispatch(setFiscalCode(text))}
                    />
                </div>
                <div className='grid grid-cols-2 gap-4'>
                    <MadfarmInput
                        label={'Cognome'}
                        placeholder="Cognome"
                        defaultValue={clientiState.rappLegaleEditCreateRequest.surname}
                        onChangeText={(text) => dispatch(setSurname(text))}
                    />
                    <MadfarmInput
                        label={'Nome'}
                        placeholder="Nome"
                        defaultValue={clientiState.rappLegaleEditCreateRequest.name}
                        onChangeText={(text) => dispatch(setName(text))}
                    />
                </div>
                <div className='grid grid-cols-2 gap-4'>
                    <MadfarmStaticSelect
                        label="Sesso"
                        placeholder={'Sesso'}
                        options={genreSelect}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(setSex(newValue))
                        }}
                        value={clientiState.rappLegaleEditCreateRequest.sex}
                        noOptionsMessage={""}
                    />
                    <Calendar
                        label="Data di nascita"
                        selected={clientiState.rappLegaleEditCreateRequest.birthdate}
                        onChange={(date) => {
                            dispatch(setBirthDate(format(new Date(date), 'yyyy-MM-dd')))
                            setDateBirthDate(date)
                        }}
                    />
                </div>
                <div className='grid grid-cols-3 gap-4'>
                    <MadfarmStaticSelect
                        isClearable
                        label="Regione"
                        error={clientiState.createLegalRappErrors.countryRegion}
                        errorLabel="Inserire Regione."
                        value={clientiState.rappLegaleEditCreateRequest.countryRegion}
                        placeholder={'Regione'}
                        options={regionOptions}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            handleRegionChange(newValue as unknown as OptionType | null);
                            dispatch(setCountryRegion(newValue));
                        }}
                        noOptionsMessage={""}
                    />
                    <MadfarmStaticSelect
                        isClearable
                        label="Provincia"
                        error={clientiState.createLegalRappErrors.province}
                        errorLabel="Inserire provincia."
                        value={clientiState.rappLegaleEditCreateRequest.province}
                        placeholder={'Provincia'}
                        options={provinceOptions}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            handleProvinceChange(newValue as unknown as OptionType | null);
                            dispatch(setProvince(newValue));
                        }}
                        noOptionsMessage={"Selezionare regione prima di selezionare provincia."}
                    />
                    <MadfarmStaticSelect
                        isClearable
                        label="Comune"
                        error={clientiState.createLegalRappErrors.city}
                        errorLabel="Inserire Città."
                        placeholder={'Comune'}
                        value={clientiState.rappLegaleEditCreateRequest.city}
                        options={comuneOptions}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            handleComuneChange(newValue as unknown as OptionType | null);
                            dispatch(setCity(newValue))
                        }}
                        noOptionsMessage={"Selezionare provincia prima di selezionare comune."}
                    />
                </div>
            </CustomAccordion>
            <CustomAccordion
                id="panel2"
                title={<span className="text-uppercase text-white label-input">Recapiti</span>}
                expanded={expanded === 'panel2'}
                onChange={() => handleToggleAccordion('panel2')}
                detailsClassName="flex flex-col gap-4"
            >
                <div className='grid grid-cols gap-4'>
                    <MadfarmInput
                        supportingText={clientiState.createLegalRappErrors.contactAddress ? "Inserire indirizzo." : undefined} error={clientiState.createLegalRappErrors.contactAddress}
                        label={'Indirizzo'}
                        placeholder="Indirizzo"
                        onChangeText={(text) => dispatch(setAddress(text))}
                        defaultValue={clientiState.rappLegaleEditCreateRequest.contactAddress}
                    />
                </div>
                <div className='grid grid-cols-2 gap-4'>
                    <MadfarmStaticSelect
                        isClearable
                        label="Regione"
                        error={clientiState.createLegalRappErrors.contactCountryRegion}
                        errorLabel="Inserire Regione."
                        value={clientiState.rappLegaleEditCreateRequest.contactCountryRegion}
                        placeholder={'Regione'}
                        options={regionOptions}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            handleRpRegionChange(newValue as unknown as OptionType | null);
                            dispatch(setContactCountryRegion(newValue))
                        }}
                        noOptionsMessage=""
                    />
                    <MadfarmStaticSelect
                        isClearable
                        label="Provincia"
                        error={clientiState.createLegalRappErrors.contactProvince}
                        errorLabel="Inserire Provincia."
                        value={clientiState.rappLegaleEditCreateRequest.contactProvince}
                        placeholder={'Provincia'}
                        options={rpProvinceOptions}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            handleRpProvinceChange(newValue as unknown as OptionType | null);
                            dispatch(setContactProvince(newValue))
                        }}
                        noOptionsMessage={"Selezionare regione prima di selezionare provincia."}
                    />
                </div>
                <div className='grid grid-cols-2 gap-4'>
                    <MadfarmStaticSelect
                        isClearable
                        label="Comune"
                        error={clientiState.createLegalRappErrors.city}
                        errorLabel="Inserire Comune."
                        value={clientiState.rappLegaleEditCreateRequest.contactCity}
                        placeholder={'Comune'}
                        options={rpComuneOptions}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(setContactCity(newValue))
                        }}
                        noOptionsMessage={"Selezionare provincia prima di selezionare comune."}
                    />
                    <MadfarmInput
                        error={clientiState.createLegalRappErrors.contactZipCode}
                        supportingText={clientiState.createLegalRappErrors.contactZipCode ? 'Deve essere di 5 caratteri!' : undefined}
                        label={'CAP'}
                        placeholder="CAP"
                        onChangeText={(text) => dispatch(setContactZipCode(text))}
                        defaultValue={clientiState.rappLegaleEditCreateRequest.contactZipCode}
                    />
                </div>
            </CustomAccordion>
            <CustomAccordion
                id="panel3"
                title={<span className="text-uppercase text-white label-input">Contatto</span>}
                expanded={expanded === 'panel3'}
                onChange={() => handleToggleAccordion('panel3')}
                detailsClassName="flex flex-col gap-4"
            >
                <div className='grid grid-cols-2 gap-4'>
                    <MadfarmInput
                        error={clientiState.createLegalRappErrors.phone}
                        supportingText={clientiState.createLegalRappErrors.phone ? 'Deve essere compreso tra 7 e 15 caratteri!' : undefined}
                        label={'Telefono'}
                        placeholder="Telefono"
                        onChangeText={(text) => dispatch(setPhone(text))}
                        defaultValue={clientiState.rappLegaleEditCreateRequest.phone}
                    />
                    <MadfarmInput
                        error={clientiState.createLegalRappErrors.mobilePhone}
                        supportingText={clientiState.createLegalRappErrors.mobilePhone ? 'Deve essere compreso tra 9 e 13 caratteri!' : undefined}
                        label={'Cellulare'}
                        placeholder="Cellulare"
                        onChangeText={(text) => dispatch(setRappLegaleMobilePhone(text))}
                        defaultValue={clientiState.rappLegaleEditCreateRequest.mobilePhone}
                    />
                </div>
                <div className='grid grid-cols-2 gap-4'>
                    <MadfarmInput
                        label={'Email'}
                        placeholder="Email" onChangeText={(text) => dispatch(setEmail(text))}
                        defaultValue={clientiState.rappLegaleEditCreateRequest.email}
                    />
                    <MadfarmInput
                        label={'Fax'}
                        placeholder="Fax"
                        onChangeText={(text) => dispatch(setFax(text))}
                        defaultValue={clientiState.rappLegaleEditCreateRequest.fax}
                    />
                </div>
            </CustomAccordion>
            <CustomAccordion
                id="panel5"
                title={<span className="text-uppercase text-white label-input">Data ingresso / Uscita</span>}
                expanded={expanded === 'panel5'}
                onChange={() => handleToggleAccordion('panel5')}
                detailsClassName="flex flex-col gap-4"
            >
                <div className='grid grid-cols-2 gap-4'>
                    <Calendar
                        label="Data Ingresso"
                        selected={clientiState.rappLegaleEditCreateRequest.activationDate}
                        onChange={(date) => {
                            dispatch(setActivationDate(format(new Date(date), 'yyyy-MM-dd')))
                            setDataActivate(date)
                        }}
                    />
                    <Calendar
                        label="Data uscita"
                        selected={clientiState.rappLegaleEditCreateRequest.deactivationDate}
                        onChange={(date) => {
                            dispatch(setDeActivationDate(format(new Date(date), 'yyyy-MM-dd')))
                            setDataDeActivate(date)
                        }}
                    />
                </div>
            </CustomAccordion >
            <CustomAccordion
                id="panel6"
                title={<span className="text-uppercase text-white label-input">Note</span>}
                expanded={expanded === 'panel6'}
                onChange={() => handleToggleAccordion('panel6')}
                detailsClassName="flex flex-col gap-4"
            >
                <TextArea label="Note" onChangeText={(text) => dispatch(setNote(text))} />
            </CustomAccordion>
        </div>
    )
}